import React from 'react'
import { SVGIconProps } from '../types'
const SvgButtonConfirm = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 6 8"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M-5-4h16v16H-5z" />
      <path
        fill="#FFF"
        d="M2.308.276 5.692 3.66a.3.3 0 0 1 0 .424L2.308 7.468A.942.942 0 0 1 .976 6.136L3.24 3.872.976 1.608A.942.942 0 0 1 2.308.276"
      />
    </g>
  </svg>
)
export default SvgButtonConfirm
